module.exports = __webpack_public_path__ + "26c66dad6c6f6ed5956262bd72bad0e0.svg";